export default "__VITE_ASSET__CRJH2eS9__"